import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

// ─── Variantlar — barcha brand ranglar tokendan keladi ──────────────────────
const variants = {
    primary: 'btn-brand',
    outline: [
        'border-2 border-brand text-brand-text',
        'hover:bg-brand-light',
    ].join(' '),
    ghost: [
        'text-secondary',
        'hover:bg-surface-2',
    ].join(' '),
};

/**
 * @param {{ variant?: 'primary'|'outline'|'ghost', isLoading?: boolean } & React.ButtonHTMLAttributes<HTMLButtonElement>} props
 */
export default function Button({
    children,
    variant = 'primary',
    isLoading = false,
    className = '',
    ...rest
}) {
    return (
        <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: 'spring', stiffness: 400, damping: 20 }}
            className={`
        flex items-center justify-center gap-2 w-full px-6 py-3.5 rounded-xl
        font-semibold text-sm tracking-wide
        focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2
        focus:ring-offset-background
        disabled:opacity-60 disabled:cursor-not-allowed
        transition-all duration-200
        ${variants[variant]} ${className}
      `}
            disabled={isLoading}
            {...rest}
        >
            {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
            {children}
        </motion.button>
    );
}
